/**
 * Excel Orchestrator — Tools Section
 *
 * Reuses the ToolLike interface from editChart/prompt/tools.ts.
 * Follows the same pattern: preamble + tool.systemPromptDescription iteration + postamble.
 */
export const EXCEL_ORCHESTRATOR_TOOLS_PREAMBLE = `## Available Tools

**Critical rules:**
- Read before write when placement is ambiguous.
- Always use explicit ranges for edits.
- Use readId lineage when available (readExcel.readCharts → editChart).
- Prompt-as-environment: if unsure about conventions, call promptSearch → promptGet BEFORE editing.`;
export const EXCEL_ORCHESTRATOR_TOOLS_POSTAMBLE = `## Tool Argument Contracts (strict)

- readExcel.readContent[] uses \`targetRange\` (not \`range\`) and required \`mode\`.
- readExcel.readFormatting[] requires \`sheetName\` and \`targetRange\`.
- readExcel.readCharts[] requires \`sheetName\` and accepts optional \`chartId\`/\`chartName\`; use before chart edits.
- readExcel.formulaTrace[] requires \`sheetName\` and \`cellAddress\`.
- readExcel.tableAnalysis[] requires \`sheetName\` and \`targetRange\`.
- readExcel.listSheets[] lists sheets and metadata (including tab colors when available).
- editContent.edits[] uses \`rangeRef\` (or numeric \`range\`) and \`content\`; if \`sheetName\` is missing, editContent creates that sheet.
- editFormat requires \`targetRange\`; optional \`sheetName\` may be provided.
- editFormat.customRangeFormatting: prefer canonical shape with \`addresses\`; border styles: thin/medium/thick/solid/dashed/dotted/double.
- editChart requires \`sheetName\` and \`action\` (\`create\`|\`edit\`|\`delete\`), with XML-first payload.
- editStructure requires \`operations[]\` with \`operation\` + \`params\`.
- externalFileSearchAgent groups external-file operations:
  - \`searchFiles\` for RAG search over uploaded files
  - \`readExcel\` for uploaded Excel reads by \`fileIndex\`
  - use \`readExcel\` for current workbook reads.
- searchAlphaSense takes \`queries[]\`; each chunk returns an \`as_*\` context ID that can be reused in later turns.
- promptSearch takes a natural-language query and returns prompt section IDs.
- promptGet takes section IDs and returns full guidance text.`;
export function getToolsPreamble() {
    return EXCEL_ORCHESTRATOR_TOOLS_PREAMBLE;
}
export function getToolsPostamble() {
    return EXCEL_ORCHESTRATOR_TOOLS_POSTAMBLE;
}
export function buildToolsSection(tools) {
    const parts = [];
    parts.push(getToolsPreamble());
    parts.push("");
    for (const tool of tools) {
        if (tool.systemPromptDescription) {
            parts.push(tool.systemPromptDescription);
            parts.push("");
        }
    }
    parts.push("---");
    parts.push("");
    parts.push(getToolsPostamble());
    return parts.join("\n");
}
